import { Route, Routes, BrowserRouter as Router, Navigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { handleSetIsMobile } from '../../redux/actions/general';

import ImportModals from './partials/ImportModals';
import AuthenticatedRoute from './authenticatedRoute';
import ProtectedRoute from './protectedRoute';
import MainDesktop from './pages/main/indexDesktop';
import MainMobile from './pages/main/indexMobile';
import Login from './pages/user/login';
import LoginVerify from './pages/user/verify';
import Profile from './pages/user/profile';
import ProfileMobile from './pages/user/profile/indexMobile';
import CategoryProductsDesktop from './pages/category/productsDesktop';
import CategoryProductsMobile from './pages/category/productsMobile';
import Cart from './pages/checkout/cart';
import CartMobile from './pages/checkout/cartMobile';
import Shipping from './pages/checkout/shipping';
import ShippingMobile from './pages/checkout/shippingMobile';
import Product from './pages/product';
import ProductMobile from './pages/product/indexMobile';
import ScrollToTop from './partials/ScrollToTop';
import Header from './partials/header/Index';
import Footer from './partials/footer/Index';
import BackDrop from './partials/BackDrop';
import Snackbar from './partials/snackbar'
import CategoriesMobile from './pages/category/categoriesMobile';
import Search from './pages/search';
import SearchMobile from './pages/search/indexMobile';
import SheetSearchMobile from './partials/sheetSearchMobile/Index.js';
import Symbols from './symbols';
import SellerPageDesktop from './pages/sellers/sellerPageDesktop';
import SellerPageMobile from './pages/sellers/sellerPageMobile';
import BestSellingDesktop from './pages/bestSelling/indexDesktop';
import BestSellingMobile from './pages/bestSelling/indexMobile';
import AmazingOffersDesktop from './pages/amazingOffers/indexDesktop';
import AmazingOffersMobile from './pages/amazingOffers/indexMobile';
import FlashSaleDesktop from './pages/flashSale/indexDesktop';
import FlashSaleMobile from './pages/flashSale/indexMobile';


const Root = () => {

    const dispatch = useDispatch();

    const { isMobile } = useSelector(state => state.general);

    useEffect(() => {
        dispatch(handleSetIsMobile(window.innerWidth < 1024));
        document.documentElement.style.setProperty('--window-inner-height', (window.innerHeight + 'px'));

        const handleResize = () => {
            dispatch(handleSetIsMobile(window.innerWidth < 1024));
            document.documentElement.style.setProperty('--window-inner-height', (window.innerHeight + 'px'));
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);


    const { phoneNumber, token } = useSelector(state => state.login);




    return (
        <Router>
            <div className={`flex flex-col bg-neutral-000 ${!isMobile ? 'h-full items-center' : ''}`}>
                <Symbols />
                <ScrollToTop />
                <ImportModals />
                <BackDrop />
                <Snackbar />
                <Header />
                <Routes> 
                    <Route path='/' element={ !isMobile ? <MainDesktop /> : <MainMobile />} />


                    <Route path='/login' element={<AuthenticatedRoute isAuthenticated={!!token}><Login /></AuthenticatedRoute>} />
                    <Route path='/login/verify' element={<AuthenticatedRoute isAuthenticated={!!token}>{phoneNumber.length === 11 ? <LoginVerify /> : <Navigate replace to={ "/login" }/>}</AuthenticatedRoute>} />
                    
                    <Route path='/profile' element={<ProtectedRoute isAuthenticated={!!token}>{ !isMobile ? <Profile /> : <ProfileMobile />}</ProtectedRoute>} />
                    <Route path='/profile/*' element={<ProtectedRoute isAuthenticated={!!token}>{ !isMobile ? <Profile /> : <ProfileMobile />}</ProtectedRoute>} />
                    
                    <Route path='/category/:catTitle' element={ !isMobile ? <CategoryProductsDesktop /> : <CategoryProductsMobile />} />
                    <Route path='/product/:slug/:title' element={ !isMobile ? <Product /> : <ProductMobile />} />

                    <Route path='/checkout/cart' element={ !isMobile ? <Cart /> : <CartMobile />} />

                    <Route path='/checkout/shipping' element={<ProtectedRoute isAuthenticated={!!token}>{ !isMobile ? <Shipping /> : <ShippingMobile />}</ProtectedRoute>} />

                    {/*<Route path='/categories' element={ isMobile ? <CategoriesMobile /> : <Navigate replace to={ "/" }/> } />*/}
                    <Route path='/categories' element={ <CategoriesMobile /> } />


                    {/*<Route path='/product' element={ !isMobile ? <Product /> : <ProductMobile />} />
                    <Route path='/product/*' element={ !isMobile ? <Product /> : <ProductMobile />} />*/}
                    
                    <Route path={"/search"} element={ !isMobile ? <Search /> : <SearchMobile /> } />
                    <Route path={"/search/:catUrl"} element={ !isMobile ? <Search /> : <SearchMobile /> } />

                    <Route path='/seller/:sellerCode' element={ !isMobile ? <SellerPageDesktop /> : <SellerPageMobile />} />
                    
                    <Route path='/best-selling' element={ !isMobile ? <BestSellingDesktop /> : <BestSellingMobile />} />
                    <Route path='/best-selling/:catId' element={ !isMobile ? <BestSellingDesktop /> : <BestSellingMobile />} />
                    
                    <Route path='/amazing-offers' element={ !isMobile ? <AmazingOffersDesktop /> : <AmazingOffersMobile />} />
                    
                    <Route path='/flash-sale' element={ !isMobile ? <FlashSaleDesktop /> : <FlashSaleMobile />} />

                    {/*<Route path={"*"} element={ <Navigate replace to={ "/login" }/> } />*/}
                </Routes>
                { isMobile &&
                    <SheetSearchMobile />
                }
                <Footer />
            </div>
        </Router>
    );

}

export default Root;
